import '@/singletons';
import { createRoot } from 'react-dom/client';

import { Root } from '@/root';

/**
 * Responsible for mounting the root component to the DOM
 */
createRoot(document.getElementById('root')!).render(<Root />);
